<template>
	<v-list density="compact">
		<v-list-item class="list-ChartContextMenu" v-for="(item, index) in items" :key="index"
			@click="onClick($event, item.id)">
			<v-list-item-title>{{ item.title }}</v-list-item-title>
		</v-list-item>
	</v-list>
</template>

<script>
export default {
	name: "RoadAiPointPickContextMenu",
	data: () => ({
		items: [
			{ id: 1, title: "完了" },
			{ id: 2, title: "進む" },
			{ id: 3, title: "戻る" },
		],
	}),
	methods: {
		onClick(e, id) {
			e.preventDefault();
			switch (id) {
				case 1:
					window["viewer"].finishRoadAiPointPick();
					break;
				case 2:
					window["viewer"].redoRoadAiPointPick();
					break;
				case 3:
					window["viewer"].undoRoadAiPointPick();
					break;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.list-ChartContextMenu:hover {
	background-color: #0064ba !important;
}
</style>
